export const HIDDEN = 'd-none'
export const SHOWN = 'd-block'
